import { ChatAppSettingKeyEnum } from '@ztechapps/common.contract'

export const AppSettingKey = {
  CHAT_AUTO_CLOSE_AFTER_DAYS: 'CHAT_AUTO_CLOSE_AFTER_DAYS',
  // Whole sender addresses the tenant marked as spam. The inbound lane reads it on arrival and
  // creates a listed sender's conversation already Cancelled; the marking actions own the writes.
  CHAT_SPAM_SENDER_LIST: ChatAppSettingKeyEnum.CHAT_SPAM_SENDER_LIST,
}
